<template>
  <div>
    <a-modal
      v-model="isActivitiShowPop.isshow"
      title="业务流程审批"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="activiti-submission">
        <a-radio-group
          v-model="formarr[0].fieldValue"
          v-if="activitiN1.length === 0 ? false : true"
        >
          <a-radio
            :value="item[0]"
            v-for="(item, ixs) in filterRadio"
            :key="ixs"
          >
            {{ item[1] }}
          </a-radio>
        </a-radio-group>
        <p
          class="activiti-line"
          v-if="activitiN1.length === 0 ? false : true"
        ></p>
        <a-textarea
          placeholder="请输入审批意见"
          v-model="formarr[1].fieldValue"
          :rows="10"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { formDataShow, completeTask } from '@/http/url'
export default {
  props: ['isActivitiMode'],
  model: {
    prop: 'isActivitiMode',
    event: 'input'
  },
  data() {
    return {
      confirmLoading: false,
      allData: [],
      formData: [],
      isActivitiShowPop: {
        isshow: false
      },
      activitiN1: [],
      activitiN2: [],
      filterRadio: [],
      formarr: [
        {
          fieldValue: '1'
        },
        {
          fieldValue: ''
        },
        {
          fieldValue: ''
        },
        {
          fieldValue: ''
        }
      ]
    }
  },
  watch: {
    isActivitiMode: {
      handler(newVal, odlVal) {
        this.allData = newVal
        this.isActivitiShowPop = {
          isshow: newVal.isActivitiShow
        }
        const params = {
          taskId: newVal.proQueryParams.taskId
        }
        formDataShow(params).then((res) => {
          if (res.data.code === 0) {
            this.formData = res.data.data
            // 同意 不同意
            let letActivitiN1 = this.formData.filter((item) => {
              if (item.fieldType === 'radio') {
                let splitSemicolon = item.initFieldValue.split(';')
                this.filterRadio = []
                splitSemicolon.forEach((el, index) => {
                  let colon = String(el).split(':')
                  this.filterRadio.push(colon)
                })
                return item.fieldType === 'radio'
              }
            })
            this.activitiN1 = letActivitiN1
            // 审批意见
            let letActivitiN2 = this.formData.filter(
              (item) => item.fieldType === 'string'
            )
            this.activitiN2 = letActivitiN2
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    showModal() {
      this.visible = true
    },
    // 取消按钮
    handleCancel() {
      this.$emit('input', false)
    },
    // 确认按钮
    handleOk() {
      if (this.formarr[0].fieldValue === '') {
        this.$message.error('请选择审批状态，是否同意')
      } else {
        this.confirmLoading = true
        let formList = []
        this.formData.forEach((el, index) => {
          let fieldKeyData = ''
          if (el.fieldType === 'param') {
            // 额外状态值
            let fieldKey = el.fieldKey
            fieldKeyData = this.allData.proQueryParams.detailsData[fieldKey]
          }
          formList.push({
            businessKey: this.allData.proQueryParams.id,
            fieldKey: el.fieldKey,
            fieldName: el.fieldName,
            fieldType: el.fieldType,
            fieldValue:
              this.formarr[index].fieldValue || fieldKeyData || el.fieldValue,
            formStep: this.allData.proQueryParams.formStep,
            formkey: el.formkey,
            initFieldValue: el.initFieldValue,
            isEdit: this.allData.proQueryParams.isEdit,
            processDefinitionId: el.processDefinitionId,
            processDefinitionKey: el.processDefinitionKey,
            processInstanceId: el.processInstanceId,
            taskId: this.allData.proQueryParams.taskId,
            taskName: el.taskName,
            userTaskId: el.userTaskId,
            whetherParam: el.whetherParam
          })
        })
        // 二期新增appid 处理针对当前appid 关闭自动审批功能
        const params = {
          formList,
          taskId: this.allData.proQueryParams.taskId,
          appId: this.$route.meta.appId
        }
        completeTask(params).then((res) => {
          if (res.data.code === 0) {
            this.$router.push({
              path: '/'
            })
            this.formData = []
            this.$message.success('审批成功')
            this.confirmLoading = false
          } else {
            this.confirmLoading = false
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.activiti-submission {
  height: auto;
  overflow: hidden;
}
.activiti-line {
  height: 20px;
  overflow: hidden;
}
</style>  



// WEBPACK FOOTER //
// src/components/approval-submission/index.vue